<template>
    <div class="scenarios main_width main_color m_0">
        <div class="title">应用场景</div>
        <div class="item1 content">
            <div class="content_left">
                <div class="content_title">商品库存管理</div>
                <div>一键扫描商品标签导入商品，助力商家快速完成品牌、种类与海量商品的信息登记。准确掌握企业库存情况，不丢失不漏记，确保库存状态即时更新。</div>
            </div>
            <img src="/static/images2/cloud_warehouse_item1.webp" alt="">
        </div>
        <div class="item2 content">
            <img src="/static/images2/cloud_warehouse_item2.webp" alt="">
            <div class="content_left">
                <div class="content_title">货物盘点记录</div>
                <div>商品库存盘点功能通过智能扫描与云端同步技术，实时展示盘点进度，支持线下仓库与线上系统数据联动，系统自动比对账实差异，助力企业实现库存精准化管理。</div>
            </div>
        </div>
        <div class="item3 content">
            <div class="content_left">
                <div class="content_title">商品出入库</div>
                <div>商品出入库功能通过智能化流程设计实现全链路高效管理，支持扫码快速录入商品信息。按订单自动匹配库存，智能拣货路径优化发货效率，降低人工误差，助力企业实现库存精准化与业务协同化管理</div>
            </div>
            <img src="/static/images2/cloud_warehouse_item3.webp" alt="">
        </div>
        <div class="item4 content">
            <img src="/static/images2/cloud_warehouse_item4.webp" alt="">
            <div class="content_left">
                <div class="content_title">采购管理</div>
                <div>支持商品智能上下架管理，实时联动库存状态并设置自动规则。关联采购订单、合同及入库单实现跨部门数据互通，系统内置动销周期模块，各环节单据联动确保业务闭环与流程透明化。</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    }
}
</script>
<style scoped lang="less">
@import "../../assets/style/utils.less";
div {
    box-sizing: border-box;
}
.scenarios {
    .title {
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        margin: .px2vw(48)[@result] 0 .px2vw(24)[@result] 0;
        text-align: center;
    }
    .content {
        font-size: .px2vw(14)[@result];
        line-height: .px2vw(22)[@result];
        color: #4E5969;
        display: flex;
        justify-content: center;
        margin-bottom: .px2vw(32)[@result];
        .content_left {
            width: .px2vw(471)[@result];
            .content_title {
                font-weight: 700;
                font-size: .px2vw(32)[@result];
                color: #1D2129;
                margin-bottom: .px2vw(16)[@result];
            }
        }
    }
    .item1 {
        padding: .px2vw(28)[@result] 0 .px2vw(23)[@result] .px2vw(48)[@result];
        .content_left {
            margin-top: .px2vw(168)[@result];
        }
        img {
            width: .px2vw(382)[@result];
            height: .px2vw(499)[@result];
            margin-left: .px2vw(121)[@result];
        }
    }
    .item2 {
        padding: .px2vw(47)[@result] 0 .px2vw(47)[@result] .px2vw(134)[@result];
        .content_left {
            margin-top: .px2vw(108)[@result];
        }
        img {
            width: .px2vw(538)[@result];
            height: .px2vw(456)[@result];
            margin-right: .px2vw(57)[@result];
        }
    }
    .item3 {
        padding: .px2vw(47)[@result] 0 .px2vw(47)[@result] .px2vw(48)[@result];
        .content_left {
            margin-top: .px2vw(108)[@result];
        }
        img {
            width: .px2vw(491)[@result];
            height: .px2vw(456)[@result];
            margin-left: .px2vw(88)[@result];
        }
    }
    .item4 {
        padding: .px2vw(53)[@result] 0 .px2vw(49)[@result] .px2vw(124)[@result];
        .content_left {
            margin-top: .px2vw(102)[@result];
        }
        img {
            width: .px2vw(438)[@result];
            height: .px2vw(448)[@result];
            margin-right: .px2vw(167)[@result];
        }
    }
}
@media screen and (max-width: 900px) {
    .scenarios {
        .title {
            font-size: .h5px2vw(32)[@result];
            margin: .h5px2vw(32)[@result] 0;
        }
        .content {
            font-size: .h5px2vw(24)[@result];
            line-height: .h5px2vw(32)[@result];
            margin-bottom: .h5px2vw(40)[@result];
            flex-direction: column-reverse;
            padding: 0 .h5px2vw(24)[@result];
            .content_left {
                width: 100%;
                .content_title {
                    font-weight: 700;
                    font-size: .h5px2vw(32)[@result];
                    line-height: .h5px2vw(40)[@result];
                    color: #1D2129;
                    margin-bottom: .h5px2vw(16)[@result];
                    text-align: center;
                }
            }
        }
        .item1 {
            .content_left {
                margin-top: .h5px2vw(32)[@result];
            }
            img {
                width: .h5px2vw(382)[@result];
                height: .h5px2vw(499)[@result];
                margin: auto;
            }
        }
        .item2 {
            flex-direction: column;
            .content_left {
                margin-top: .h5px2vw(32)[@result];
            }
            img {
                width: .h5px2vw(538)[@result];
                height: .h5px2vw(456)[@result];
                margin: auto;
            }
        }
        .item3 {
            .content_left {
                margin-top: .h5px2vw(32)[@result];
            }
            img {
                width: .h5px2vw(491)[@result];
                height: .h5px2vw(456)[@result];
                margin: auto;
            }
        }
        
        .item4 {
            flex-direction: column;
            .content_left {
                margin-top: .h5px2vw(32)[@result];
            }
            img {
                width: .h5px2vw(438)[@result];
                height: .h5px2vw(448)[@result];
                margin: auto;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudWarehouse/scenarios.vue